module.exports = __webpack_public_path__ + "img/公司介绍.dd2d0fbe.jpg";